/** Staged rollout must never leave the old AI endpoint as a second quota. */
export function legacyTutorAllowed(setting: boolean | null, lookupFailed = false): boolean {
  return !lookupFailed && setting === false;
}

export function remainingDailyQuestions(usage: { count: number; limit: number; reservedDaily?: number }): number | null {
  return usage.limit === -1 ? null : Math.max(0, usage.limit - usage.count - (usage.reservedDaily ?? 0));
}